// Must stay first: this initialises Sentry before any other app module is
// imported, so its global handlers are armed before ./App evaluates appkit.ts's
// web3 init at import time. See sentry.ts.
import './sentry'
import React from 'react'
import './index.css'
import { createRoot } from 'react-dom/client'
import App from './App'
import { NODE_ENV } from './constants'

// biome-ignore lint/suspicious/noConsole: <useful information>
console.debug('Environment: ' + NODE_ENV)

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
